module.exports = __webpack_public_path__ + "static/media/polka-cut.91d58da0.ogg";